export default function() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: IPADDETECTED
      // options
      , allEventsLink: true
      , allEventsLinkText: 'View all Events'
      , hasImages: true
      , imageBackground: true
      , lazyLoadImages: true
      , buyNowButton: {visible: true, text: 'MORE'}
      , moreButton: {visible: false, text: 'MORE >'}
      , maxItemsVisible: 5
      , isResponsive: false
      , hasDescription: false
      , textContainer: true
      , link: '' //options are 'all', 'text', 'image', 'imageAndText', or ''

      , attributeOrder: {
        1: 'date',
        2: 'image',
        3: 'title',
        4: 'description',
        5: 'buttons'
      }
      , multiFeatureLoaded: function(data){

        
        $('.all-events-btn')
          .addClass('button')
          .appendTo('#multiScheduleFeature');

        $('#multiScheduleFeature .featureItem').each(function(i) {

          // hide button if no url
          if (!data[i].URL) {
            $(this).find('.button-container').hide();
          }

          if (!data[i].ImageURL) {
            var img = $(this).find('.featureItemImage');
            img.removeClass('lozad');
            img.css('background-image', `url("https://cdn.saffire.com/images.ashx?t=ig&rid=WalworthCountyFair&i=no-image(6).png")`);
          }
          
          // Place button container
          const buttonContainer = $(this).find('.button-container');
          const textContainer = $(this).find('.text-container');
          
          buttonContainer.appendTo(textContainer);

          // Format date
          const eventDate = $(this).find('.featureItemDate');

          eventDate.prependTo(this);

          const datesMonth = eventDate.text().slice(0,3);
          const datesDay = eventDate.text().slice(4,7).replace(',','');
          const datesYear = eventDate.text().slice(-4);

          eventDate.text(datesMonth);
          eventDate.append(`<span class='day'>${datesDay}</span><span class='year'>${datesYear}</span>`);

          // Description limit + placement
          const itemDescription = $(this).find('.featureItemDescription');
          const imageContainer = $(this).find('.featureItemImage');

          itemDescription.appendTo(imageContainer);

          const descCharacterLimit = 150;
          const itemDescriptonText = itemDescription.text();

          if (itemDescriptonText.length === 0) {
            itemDescription.hide();
          }

          if (itemDescriptonText.length > descCharacterLimit) {
            const trimmedText = itemDescriptonText.substring(0,descCharacterLimit) + '...';
            itemDescription.text(trimmedText);
          }

          // Title limit
          const titleCharacterLimit = 35;
          const itemTitle = $(this).find('.featureItemTitle');
          const itemTitleText = itemTitle.text();

          if (itemTitleText.length > titleCharacterLimit) {
            const trimmedText = itemTitleText.substring(0,titleCharacterLimit) + '...';
            itemTitle.text(trimmedText);
          }
        });
      }
  });

};

